interface SelectionHeaderProps {
  selectedCount: number;
  onRefresh: () => void;
  onDelete: () => void;
  onDeselectAll: () => void;
}

export function SelectionHeader({
  selectedCount,
  onRefresh,
  onDelete,
  onDeselectAll,
}: SelectionHeaderProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-between border-b bg-muted/30 px-4 py-3">
      <span className="text-[14px] text-[#051923]">
        {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
      </span>

      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={onRefresh}
          className="text-[14px] font-medium text-[#051923] underline hover:no-underline"
        >
          Refresh
        </button>
        <button
          type="button"
          onClick={onDelete}
          className="text-[14px] font-medium text-[#051923] underline hover:no-underline"
        >
          Delete
        </button>
        <button
          type="button"
          onClick={onDeselectAll}
          className="text-[14px] font-medium text-[#051923] underline hover:no-underline"
        >
          Deselect All
        </button>
      </div>
    </div>
  );
}
